import Player from '@vimeo/player'

class Gallery {
    constructor(gallery) {
        this.gallery = gallery
        this.arrowBtns = gallery.querySelectorAll('.glide__arrow')
        this.arrowBtns.forEach((btn) => {
            btn.addEventListener('click', () => this.onArrowBtnClick())
        })
        this.pauseAllVideos()
    }

    onArrowBtnClick() {
        this.pauseAllVideos()
    }

    pauseAllVideos() {
        const iframes = this.gallery.querySelectorAll('[data-video=embedVideo]')
        iframes.forEach((iframe) => {
            if (iframe.nodeName !== 'IFRAME') return
            if (!iframe.getAttribute('src')) return
            const iframePlayer = new Player(iframe)
            iframePlayer.pause()
        })
        const videos = this.gallery.querySelectorAll('video')
        videos.forEach((video) => video.pause())
    }
}

if (document.readyState !== 'loading') {
    const galleries = document.querySelectorAll('.js-media-gallery .glide')
    galleries.forEach((gallery) => new Gallery(gallery))
} else {
    document.addEventListener('DOMContentLoaded', initMediaGallery)
}
